<template>
  <div>
    <h4 class="headingLv4" v-html="text"></h4>
    <span v-if="label === 'req'" class="headingLv4_label">必須</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'HeadingLv4',

  props: {
    text: String,
    label: String
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.headingLv4 {
  margin-top: 30px;
  font-size: 1.4rem;
  font-weight: 600;
  display: inline-block;

  &_label {
    margin-left: 10px;
    font-size: 1rem;
    display: inline-block;
    width: 50px;
    height: 20px;
    font-style: normal;
    font-weight: bold;
    background-color: var.$color-main;
    color: #fff;
    text-align: center;
    line-height: 20px;
    font-weight: 900;
  }
}
</style>
